import React, { Fragment } from 'react'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        console.log(error, errorInfo)
    }

    render() {
        if (this.state.hasError) {
            // 폴백 UI를 커스텀하여 렌더링할 수 있습니다.
            return <h1>page 화면 출력에 오류가 발생했습니다.</h1>
        }
        return <Fragment>{this.props.children}</Fragment>
    }
}

export default ErrorBoundary
